import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { url, url_ws } from "src/app/config/config";
import { map } from "rxjs/operators";

@Injectable()
export class UsersService {
  public myUrl = url_ws + "users/";

  constructor(private http: HttpClient) {}

  public loginUsers(user: any) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(user);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myUrl + "LoginUsers.php", body, { headers: headers })
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  getAllUsers() {
    let headers = new HttpHeaders();

    headers.append("Content-Type", "application/json");
    return this.http
      .get(this.myUrl + "getUsers.php", { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getAllUsersActivate() {
    let headers = new HttpHeaders();

    headers.append("Content-Type", "application/json");
    return this.http
      .get(this.myUrl + "getUsers.php", { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  public getUserId(id) {
    let headers = new HttpHeaders();

    return this.http
      .get(this.myUrl + "getUserId.php?id=" + id, { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  public createUser(user) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(user);
    headers.append("Content-Type", "application/json");

    return this.http
      .post(this.myUrl + "/create", body, { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
  public createUserFile(user, file: File) {
    const formData = new FormData();
    formData.append("myfile", file);
    formData.append("users", JSON.stringify(user));

    let headers = new HttpHeaders();
    let body = JSON.stringify(user);
    console.log("Service USer", body);
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Content-Type", "application/json");

    return this.http
      .post(this.myUrl + "createUsersFile.php", formData, { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
  public updateUser(user) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(user);
    // console.log(body);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myUrl + "/updateUsers.php", body, { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  public updateUserFile(user, file: File) {
    //console.log("service file ",file);

    const formData = new FormData();
    formData.append("myfile", file);
    formData.append("users", JSON.stringify(user));

    let headers = new HttpHeaders();

    // console.log("Service User", formData.get('myfile'));
    headers.append("Content-Type", "multipart/form-data");

    return this.http
      .post(this.myUrl + "updateUser.php", formData, { headers: headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  deleteUser(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    const params = new HttpParams()
      .set("id", id.toString())
      .set("database", database);

    return this.http.delete(url_ws + "generic/delete.php", { params }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getRoleStorage() {
    
  }
}
